import { Component } from '@angular/core';
import { TourService } from 'ngx-tour-ngx-popper';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
 
  constructor(
    public tourService: TourService 
  ) { 
  
  }

  proximoPasso(){
    if (this.tourService.currentStep.stepId == "stepId.AutenticacaoPin"){
      $('#modalCadastrarPin').modal('show');
    } else if (this.tourService.currentStep.stepId == "stepId.AutenticacaoeToken"){
      $('#modalCadastrarToken').modal('show');
    } else {
      this.tourService.next();
    }
  }
}
